import React, { Component, useContext, useEffect, useState } from "react";
import Card from "../../../UX/Card/Card";
import L from "leaflet";
import axios from "axios";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { TranslationContext } from "../../../Providers/TranslationProvider";

const provider = new OpenStreetMapProvider();
const searchControl = new GeoSearchControl({
    provider: provider,
    style: "bar",
    autoComplete: true,
    autoCompleteDelay: 250,
    showMarker: false,
    searchLabel: "Zoek op plaats"
});
import "leaflet-geosearch/dist/style.css";
import "leaflet-geosearch/assets/css/leaflet.css";
import styled from "styled-components";
import { ProductOptionStepsContext } from "../../../Providers/ProductOptionStepsProvider";
import StepContainer from "../../../UX/StepContainer/StepContainer";

const Wrapper = styled.div`
    width: 100%;
    height: 400px;
`;

export default class Verspreiden extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        geoResults: "",
        zipCodes: [],
        countTotal: 0,
        markers: [],
        polymarkers: [],
        selection: [],
        infoTekst: {},
        town: []
    };

    opties = {
        style: {
            default: {
                color: "#cbc901",
                weight: 0.5,
                fillColor: "#eeeeee",
                fillOpacity: 0.4
            },
            highlight: {
                color: "#cbc901",
                weight: 0.5,
                fillOpacity: 0.4,
                fillColor: "orange"
            },
            selected: {
                color: "#cbc901",
                weight: 0.5,
                fillOpacity: 0.7,
                fillColor: "orange"
            },
            highlightselected: {
                color: "#cbc901",
                weight: 0.5,
                fillOpacity: 1,
                fillColor: "orange"
            }
        }
    };

    onEachFeature = (feature, layer) => {
        layer.setStyle(this.opties.style.default);

        layer.on("click", e => {
            if (
                !this.state.selection.includes(layer.feature.properties.zipcode)
            ) {
                layer.setStyle(this.opties.style.selected);
                this.setState({
                    selection: [
                        ...this.state.selection,
                        e.target.feature.properties.zipcode
                    ]
                });
                this.setState(prevState => {
                    return {
                        countTotal:
                            prevState.countTotal +
                            e.target.feature.properties.amount
                    };
                });
                this.setState({
                    zipCodes: {
                        ...this.state.zipCodes,
                        [layer.feature.properties.municipality]: {
                            ...this.state.zipCodes[
                                layer.feature.properties.municipality
                            ],
                            [layer.feature.properties.zipcode]:
                                layer.feature.properties.amount
                        }
                    }
                });
                this.setState({
                    town: {
                        ...this.state.town,
                        [layer.feature.properties.zipcode]:
                            layer.feature.properties.town
                    }
                });
            } else {
                layer.setStyle(this.opties.style.default);
                var array = [...this.state.selection]; // make a separate copy of the array
                var index = array.indexOf(
                    parseInt(layer.feature.properties.zipcode)
                );
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({ selection: array });
                }

                var array2 = this.state.town;
                delete array2[layer.feature.properties.zipcode];
                this.setState({ town: array2 });

                this.setState(prevState => {
                    return {
                        countTotal:
                            prevState.countTotal -
                            e.target.feature.properties.amount
                    };
                });
                this.setState({
                    zipCodes: {
                        ...this.state.zipCodes,
                        [layer.feature.properties.municipality]: {
                            ...this.state.zipCodes[
                                layer.feature.properties.municipality
                            ],
                            [layer.feature.properties.zipcode]: undefined
                        }
                    }
                });
            }
        });
        layer.on("mouseover", e => {
            this.setState({
                infoTekst: {
                    zip: layer.feature.properties.zipcode,
                    town: layer.feature.properties.town,
                    amount: layer.feature.properties.amount
                }
            });
            e.target.setStyle(
                this.state.selection.includes(layer.feature.properties.zipcode)
                    ? this.opties.style.highlightselected
                    : this.opties.style.highlight
            );
        });
        layer.on("mouseout", e => {
            e.target.setStyle(
                this.state.selection.includes(layer.feature.properties.zipcode)
                    ? this.opties.style.selected
                    : this.opties.style.default
            );
        });
    };

    componentDidMount() {
        this.map = L.map("map", {
            bounds: [[53.62, 2.931], [50.763, 7.182]],
            center: [52, 5],
            zoom: 7,
            maxZoom: 15,
            attributionControl: true,
            zoomControl: true,
            doubleClickZoom: true,
            scrollWheelZoom: true,
            dragging: true,
            animate: true,
            easeLinearity: 0.35
        });

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        }).addTo(this.map);

        axios
            .get("getverspreidendata")
            .then(res =>
                this.setState(
                    {
                        geoResults: res.data
                    },
                    async () => {
                        this.geoJson = L.geoJSON(this.state.geoResults, {
                            style: this.opties.style.default,
                            onEachFeature: this.onEachFeature.bind(this)
                        }).addTo(this.map);
                    }
                )
            );
        this.map.addControl(searchControl);
    }

    removeZip(zip, amount, gemeente, e) {
        var array = [...this.state.selection];
        var index = array.indexOf(parseInt(zip));
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ selection: array });
        }
        var array2 = this.state.town;
        delete array2[zip];
        this.setState({ town: array2 });

        this.setState(prevState => {
            return { countTotal: prevState.countTotal - amount };
        });
        this.setState({
            zipCodes: {
                ...this.state.zipCodes,
                [gemeente]: {
                    ...this.state.zipCodes[gemeente],
                    [zip]: undefined
                }
            }
        });
    }
    static contextType = ProductOptionStepsContext;

    clearAllSelected() {
        this.setState({
            zipCodes: [],
            selection: [],
            countTotal: 0,
            geoResults: ""
        });
        this.context.onClearSelectedProductOptions(this.props.step.id);

        this.geoJson.clearLayers();
        axios
            .get("getverspreidendata")
            .then(res =>
                this.setState(
                    {
                        geoResults: res.data
                    },
                    async () => {
                        this.geoJson.addData(this.state.geoResults);
                    }
                )
            );
    }

    buttons = (
        <>
            <button
                onClick={() => onOpenModal(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm"
            >
                <i className="fas fa-info-circle" /> Meer informatie
            </button>
            <button
                onClick={() => onClearSelectedProductOptions(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm "
            >
                <i className="fas fa-times" /> Verwijder keuze
            </button>
        </>
    );

    render() {
        const { step } = this.props;
        let contextValue = this.context;

        return (
            <StepContainer step={step} buttons={this.buttons}>
                <div className="w-full bg-white p-4 rounded border border-gray-200">
                    <p className="mb-4">
                        Zoek hieronder de plaats op waar je wilt verspreiden.
                        Selecteer elk postcode gebied door te klikken.
                    </p>
                    <Wrapper id="map">
                        {this.state.infoTekst && (
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "10px",
                                    left: "10px",
                                    width: "130px",
                                    height: "60px",
                                    backgroundColor: "white",
                                    opacity: "1",
                                    zIndex: "999",
                                    fontSize: "10px"
                                }}
                            >
                                <span style={{ paddingLeft: "3px" }}>
                                    Aantal: {this.state.infoTekst.amount}
                                </span>
                                <br />
                                <span style={{ paddingLeft: "3px" }}>
                                    Postcode: {this.state.infoTekst.zip}
                                </span>
                                <br />
                                <span style={{ paddingLeft: "3px" }}>
                                    Plaats: {this.state.infoTekst.town}
                                </span>
                            </div>
                        )}
                    </Wrapper>
                    {this.state.zipCodes && (
                        <div className="mt-8">
                            {Object.entries(this.state.zipCodes).map(
                                ([gemeente, zipcodes]) => (
                                    <div key={gemeente}>
                                        {zipcodes && (
                                            <h6 className="font-bold mb-1">
                                                Gemeente: {gemeente}
                                            </h6>
                                        )}

                                        {Object.entries(zipcodes).map(
                                            ([zip, amount]) =>
                                                typeof amount !==
                                                    "undefined" && (
                                                    <div
                                                        key={zip}
                                                        className="flex flex-wrap -mx-2"
                                                    >
                                                        <div className="w-5/12 px-2">
                                                            {
                                                                this.state.town[
                                                                    zip
                                                                ]
                                                            }{" "}
                                                            - postcodegebied:{" "}
                                                            <b>{zip}</b>
                                                        </div>
                                                        <div className="w-5/12 px-2">
                                                            <div>
                                                                Aantal adressen:{" "}
                                                                <b>{amount}</b>
                                                            </div>
                                                        </div>
                                                        <div className="w-2/12 flex justify-end px-2">
                                                            <button
                                                                className="removeZipcode text-red-500 text-2xl"
                                                                onClick={e =>
                                                                    this.removeZip(
                                                                        zip,
                                                                        amount,
                                                                        gemeente,
                                                                        e
                                                                    )
                                                                }
                                                            >
                                                                <i className="fas fa-times" />
                                                            </button>
                                                        </div>
                                                        <hr className="w-full mb-4" />
                                                    </div>
                                                )
                                        )}
                                    </div>
                                )
                            )}
                            <div>
                                {this.state.countTotal > 0 && (
                                    <p className="mb-4">
                                        <b>Totaal: {this.state.countTotal}</b>
                                    </p>
                                )}
                                {this.state.countTotal > 100000 && (
                                    <p className="mb-4">
                                        <b>
                                            Het totaal mag niet boven de 100000
                                            komen.
                                        </b>
                                    </p>
                                )}
                            </div>
                            {this.state.countTotal < 100000 &&
                                step.options.map(option => (
                                    <ProductOptionStepsContext.Consumer
                                        key={option.value}
                                    >
                                        {value =>
                                            option.fields.map(field => (
                                                <React.Fragment
                                                    key={option.value}
                                                >
                                                    <VerspreidGebied
                                                        key={field.id}
                                                        step={step}
                                                        field={field}
                                                        value={this.state.selection.join(
                                                            "x"
                                                        )}
                                                        option={option}
                                                        onUpdateProductOptionField={
                                                            value.onUpdateProductOptionField
                                                        }
                                                        onCheckIfStepIsDone={
                                                            value.onCheckIfStepIsDone
                                                        }
                                                        onClearSelectedProductOptions={
                                                            value.onClearSelectedProductOptions
                                                        }
                                                        onSetStepDone={
                                                            value.onSetStepDone
                                                        }
                                                    />
                                                </React.Fragment>
                                            ))
                                        }
                                    </ProductOptionStepsContext.Consumer>
                                ))}
                        </div>
                    )}
                </div>
            </StepContainer>
        );
    }
}

const VerspreidGebied = ({
    field,
    value,
    option,
    step,
    onUpdateProductOptionField,
    onCheckIfStepIsDone,
    onSetStepDone,
    onClearSelectedProductOptions,
    onSetStepDoneWithoutFetch
}) => {
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        onUpdateProductOptionField(step.id, option.value, field.id, value);
    }, [value]);

    const buttonClick = stepId => {
        onCheckIfStepIsDone(stepId);
    };

    return (
        <React.Fragment key={field.id}>
            <div className="cell large-6">
                {value && (
                    <div className="cell large-12">
                        <button
                            className="bg-yellow-200 text-yellow-900 px-4 py-2 text-white rounded mr-2 font-bold hover:bg-yellow-400"
                            onClick={() => buttonClick(step.id)}
                        >
                            Volgende stap
                        </button>
                    </div>
                )}
                {errors.length > 0 && (
                    <div className="border border-red-400 rounded p-4 mt-4">
                        {errors.map(
                            err => err && <p key={err.id}>{err.msg}</p>
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
